export const PERMISSIONS = {
  CONFERENCE: 'league_live_conference_read',
  COMPANY: 'league_live_company_read',
};
